import { type TranslationIDs, useIntl } from '@capsicum/common';
import { type PrimitiveType } from 'react-intl';
import styled from 'styled-components';

interface BaseTutorialCard {
	content: TranslationIDs;
	contentValues?: Record<string, PrimitiveType>;
	title?: TranslationIDs;
	titleValues?: Record<string, PrimitiveType>;
}

export const BaseTutorialCard = ({ content, contentValues, title, titleValues }: BaseTutorialCard) => {
	const { $t } = useIntl();

	return (
		<>
			{!!title && <S.Title>{$t(title, titleValues)}</S.Title>}
			<S.Content>{$t(content, contentValues)}</S.Content>
		</>
	);
};

namespace S {
	export const Title = styled.div`
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const Content = styled.div`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
